module.exports = __webpack_public_path__ + "media/assets/hmotors-logo-new-08b2f43aceb054284d998e1fb2ee0eff.png";